export const STAT_GROUPS = [
    {
        key: 'new_cases',
        statuses: ['new', 'new_restart'],
        color: 'primary',
        textColor: 'white',
    },
    {
        key: 'in_progress',
        statuses: ['waiting_mandatory_reimbursement_file', 'waiting_sending', 'waiting_invoice'],
        color: 'info',
        textColor: 'white',
    },
    {
        key: 'sent_waiting_pay',
        statuses: ['sent', 'waiting_paiement', 'verification_paiement'],
        color: 'warning',
        textColor: 'white',
    },
    {
        key: 'to_restart',
        statuses: ['restart_refund', 'restart_refund_impossible_internal', 'restart_refund_impossible_ask_document', 'restart_refund_impossible_ask_invoice'],
        color: 'danger',
        textColor: 'white',
    },
    {
        key: 'to_confirm',
        statuses: ['to_be_confirm', 'impossible_invoicing_internal', 'impossible_invoicing_waiting_customer', 'canceled_internal', 'canceled_waiting_customer'],
        color: 'dark',
        textColor: 'white',
    },
];
